import { render, staticRenderFns } from "./sharedialog.vue?vue&type=template&id=a091f78e&scoped=true"
import script from "./sharedialog.vue?vue&type=script&lang=js"
export * from "./sharedialog.vue?vue&type=script&lang=js"
import style0 from "./sharedialog.vue?vue&type=style&index=0&id=a091f78e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a091f78e",
  null
  
)

export default component.exports